<template lang="pug">
  div
    header
      main-header(
        :notificacao="false"
        :hasListagemModelo="false"
      )
    .content-route-view
    app-modal-alterar-perfil(
      v-if="alterarPerfil",
      :cpfCnpj="usuarioSelecionado.cpfCnpj",
      @closeModal="closeModal"
    )
    app-modal-bloquear-usuario(
      v-if="bloquearUsuario",
      :usuario="usuarioSelecionado",
      :isBloqueio="isBloqueio"
      @closeModal="closeModal"
    )
    app-modal-historico-alteracao-usuario(
      v-if="historicoUsuario",
      :idUsuario="usuarioSelecionado.id",
      @closeModal="closeModal"
    )
    app-modal-visualizar-usuario(
      v-if="visualizarUsuario",
      :usuario="usuarioSelecionado",
      @closeModal="closeModal"
    )
    app-modal-assinatura-token(
      v-if="showModalAssinaturaToken"
      :usuario="usuarioSelecionado"
      @closeModal="closeModal"
    )
    el-card(shadow="hover").card.margin-bottom
      h1(v-if="isPesquisaSimples") Pesquisa simplificada
      h1(v-else) Pesquisa avançada
      app-search-usuarios(
        @simpleSearch="simpleSearch",
        @advancedInput="advancedSearch",
        @clear="resetSearch",
        @tipoPesquisaChanged="handleTipoPesquisaChanged",
      )
    el-card(shadow="hover").card
      el-row
        el-col(:span="12")
          h1 Usuários cadastrados
        el-col(:span="12")
          .button
            el-button(
              @click="novoCadastro",
              type="success"
            )
              span.center
                i.fa.fa-plus
                span &nbsp Cadastrar
      app-divider(
        label="Listagem de usuários cadastrados",
      )
      el-row
        el-table(
          :data="usuarios"
          empty-text="Não foram encontrados usuários com os dados informados"
          @sort-change="changeOrder"
        )
          el-table-column(
            width='100',
            align='center',
            label="Situação",
            prop="situacao"
            sortable
          )
            template(slot-scope='scope')
              el-tooltip(
                effect='dark',
                placement='left',
                :content="formatSituacao(scope.row)",
              )
                div
                  i.fa.fa-ban(v-if="scope.row.bloqueado")
                  i.fa.fa-minus(v-else-if="!scope.row.ativo")
                  i.fa.fa-check.ativo(v-else)
          el-table-column(
            width='100',
            align='center',
            label="Assinatura/Token",
            sortable
          )
            template(slot-scope='scope')
              el-tooltip(
                effect='dark',
                placement='left',
                :content="formatAssinaturaToken(scope.row)",
              )
                div
                  i(v-if="scope.row.assinaturaSimbolica && scope.row.tokenPath !== ''").ativo.material-icons done_all
                  i.fa.fa-check.ativo(v-else-if="(scope.row.assinaturaSimbolica && scope.row.tokenPath === '') || (!scope.row.assinaturaSimbolica && scope.row.tokenPath !== '')")
                  i.fa.fa-minus(v-else)
          el-table-column(
            prop="nomeRazaoSocial",
            align="left",
            label="Nome/Razão Social",
            sortable
          )
          el-table-column(
            prop="email",
            align="left",
            label="E-mail",
            sortable
          )
          el-table-column(
            prop="cpfCnpj",
            align="center",
            label="CPF/CNPJ"
          )
          el-table-column(
            prop="perfis",
            align="left",
            label="Perfis"
          )
            template(slot-scope="scope")
              .lista
                ul(v-for="perfil in scope.row.perfis ?  scope.row.perfis.split(',') : []")
                  li {{perfil}}
          el-table-column(
            label='Ações',
            width='120',
            align='center'
          )
            template(slot-scope='scope')
              el-dropdown(trigger="click")
                el-button(type='primary', size="mini")
                  | Ações
                  i.el-icon-arrow-down.el-icon--right
                el-dropdown-menu(slot='dropdown')
                  el-dropdown-item
                    .flex(@click="modalVisualizar(scope.row)")
                      i.fas.fa-eye
                      | &nbsp Visualizar
                  el-dropdown-item(v-if="!scope.row.bloqueado")
                    .flex(@click="editarUsuario(scope.row)")
                      i.fas.fa-pencil-alt
                      | &nbsp Editar
                  el-dropdown-item(v-if="!scope.row.bloqueado")
                    .flex(@click="modalAlterarPerfil(scope.row)")
                      i.fas.fa-user-circle
                      | &nbsp Alterar Perfil
                  el-dropdown-item(v-if="!scope.row.bloqueado")
                    .flex(@click="redefinirSenha(scope.row)")
                      i.fas.fa-key
                      | &nbsp Redefinir Senha
                  el-dropdown-item(v-if="!scope.row.bloqueado && usuarioLogado.id !== scope.row.id && scope.row.ativo")
                    .flex(@click="modalBloquear(scope.row)")
                      i.fas.fa-ban
                      | &nbsp Bloquear
                  el-dropdown-item(v-if="scope.row.bloqueado && !scope.row.ativo && !isUsuarioLogado(scope.row)")
                    .flex(@click="modalDesbloquear(scope.row)")
                      i.far.fa-unlock-alt
                      | &nbsp Desbloquear
                  el-dropdown-item
                    .flex(@click="historicoAlteracaoUsuario(scope.row)")
                      i.fas.fa-history
                      | &nbsp Histórico
                  el-dropdown-item
                    .flex(@click="getInfoAssinaturaToken(scope.row)")
                      i.fas.fa-pencil-alt
                      | &nbsp Assinatura/Token

        app-paginacao(
          :total="total",
          :pagina="paginaAtual",
          @changePage="changePage"
        )

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AppDivider from '@/components/AppDivider'
import AppPaginacao from '@/components/AppPaginacao'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppSearchUsuarios from '@/screens/portal/seguranca/components/AppSearchUsuarios.vue'
import AppModalVisualizarUsuario from '@/screens/portal/seguranca/components/AppModalVisualizarUsuario.vue'
import AppModalBloquearUsuario from '@/screens/portal/seguranca/components/AppModalBloquearUsuario.vue'
import AppModalAlterarPerfil from '@/screens/portal/seguranca/components/AppModalAlterarPerfil.vue'
import AppModalHistoricoAlteracaoUsuario from '@/screens/portal/seguranca/components/AppModalHistoricoAlteracaoUsuario.vue'
import AppModalAssinaturaToken from '@/screens/portal/seguranca/components/AppModalAssinaturaToken.vue'
import MainHeader from '@/components/MainHeader.vue'

export default {

  components: {
    AppDivider,
    AppPaginacao,
    AppSearchUsuarios,
    MainHeader,
    AppModalVisualizarUsuario,
    AppModalBloquearUsuario,
    AppModalAlterarPerfil,
    AppModalHistoricoAlteracaoUsuario,
    AppModalAssinaturaToken
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      paginaAtual: 1,
      total: 0,
      usuarioSelecionado: undefined,
      pesquisaSimplificada: '',
      pesquisaAvancada: {},
      isPesquisaSimples: true,
      visualizarUsuario: false,
      bloquearUsuario: false,
      isBloqueio: true,
      alterarPerfil: false,
      historico: [],
      usuarios: [],
      historicoUsuario: false,
      ordenacao: undefined,
      showModalAssinaturaToken: false
    }
  },

  async created () {
    this.changePage(1, false)
    this.simpleSearch('')
  },

  computed: {
    ...mapGetters({
      usuarioLogado: 'auth/usuarioLogado'
    })
  },

  methods: {
    ...mapActions({
      findUsuarios: 'usuario/findUsuariosByFilter',
      blockUsuario: 'usuario/bloquearUsuarioByCpfCnpj',
      usuarioHasProcesso: 'usuario/usuarioHasProcesso',
      findUsuarioByCpfCnpj: 'usuario/findUsuarioByCpfCnpj',
      getInfoTokenAssinatura: 'usuario/getInfoTokenAssinatura',
      requestRedefinirSenha: 'usuario/requestRedefinirSenha'
    }),

    changeOrder (column) {
      this.changePage(1, false)
      this.ordenacao = column.order ? column : null
      this.simpleSearch(this.pesquisaSimplificada, column)
    },

    novoCadastro () {
      this.$router.push({
        name: 'cadastroUsuario',
        params: {
          tipo: 'cadastro'
        }})
    },

    formatSituacao (usuario) {
      if (usuario.bloqueado) {
        return 'Bloqueado'
      }
      return usuario.ativo ? 'Ativo' : 'Inativo'
    },

    formatAssinaturaToken (usuario) {
      if (usuario.assinaturaSimbolica && usuario.tokenPath !== '') {
        return 'Contém Assinatura e Token'
      } else if (usuario.assinaturaSimbolica && usuario.tokenPath === '') {
        return 'Contém apenas Assinatura'
      } else if (!usuario.assinaturaSimbolica && usuario.tokenPath !== '') {
        return 'Contém apenas Token'
      }
      return 'Não contém Assinatura nem Token'
    },

    async simpleSearch (filter) {
      this.usuarios = []
      const pagina = this.pesquisaSimplificada === filter ? this.paginaAtual - 1 : 0
      this.pesquisaSimplificada = filter

      const page = this.ordenacao ? await this.findUsuarios({
        pesquisaSimplificada: filter,
        pagina: pagina,
        ordem: this.ordenacao.prop,
        direction: this.ordenacao.order
      }) : await this.findUsuarios({
        pesquisaSimplificada: filter,
        pagina: pagina
      })

      this.usuarios = _.orderBy(page.content, ['pessoa.nomeRazaoSocial'], ['asc']) // eslint-disable-line
      this.total = page.totalElements
    },

    async advancedSearch (filter) {
      this.usuarios = []
      filter.pagina = JSON.stringify(filter) === JSON.stringify(this.pesquisaAvancada) ? this.paginaAtual - 1 : 0

      filter.simplificado = false

      // Copia o objeto sem manter a referencia
      this.pesquisaAvancada = JSON.parse(JSON.stringify(filter))

      const page = await this.findUsuarios(filter)

      this.usuarios = _.orderBy(page.content, ['pessoa.nomeRazaoSocial'], ['asc']) // eslint-disable-line
      this.total = page.totalElements
      this.changePage(filter.pagina + 1, false)
    },

    changePage (newPage, reset) {
      if (newPage !== this.paginaAtual || reset) {
        this.searchUsuarios(newPage)
      }
    },

    searchUsuarios (newPage) {
      this.usuarioSelecionado = undefined
      this.paginaAtual = newPage

      if (this.isPesquisaSimples) {
        this.simpleSearch(this.pesquisaSimplificada)
      } else {
        this.advancedSearch(this.pesquisaAvancada)
      }
    },

    handleTipoPesquisaChanged (simples) {
      this.isPesquisaSimples = simples
      this.resetSearch()
    },

    resetSearch () {
      this.pesquisaSimplificada = ''
      this.pesquisaSimples = ''
      this.pesquisaAvancada = {}
      this.changePage(1, true)
    },

    async modalVisualizar (usuario) {
      this.usuarioSelecionado = await this.findUsuarioByCpfCnpj(usuario.login)
      this.visualizarUsuario = true
    },

    async redefinirSenha (usuario) {
      this.confirmBox(this.$messages.REDEFINIR_SENHA_WARNING, this.$messages.TITULO_WARNING,
        async () => {
          await this.requestRedefinirSenha({cpfCnpj: usuario.cpfCnpj})

          this.showNotificacao(
            this.$messages.TIPO_SUCCESS,
            this.$messages.TITULO_SUCCESS,
            this.$messages.SOLICITACAO_REDEFINICAO_SENHA_SUCESSO
          )
        },
        () => {}
      )
    },

    async modalAlterarPerfil (usuario) {
      this.usuarioSelecionado = usuario
      this.alterarPerfil = true
    },

    async modalBloquear (usuario) {
      if (!await this.usuarioHasProcesso(usuario.cpfCnpj)) {
        this.usuarioSelecionado = usuario
        this.isBloqueio = true
        this.bloquearUsuario = true
      } else {
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          this.$messages.USUARIO_BLOQUEAR_ERRO_PROCESSOS
        )
      }
    },

    async modalDesbloquear (usuario) {
      this.usuarioSelecionado = usuario
      this.isBloqueio = false
      this.bloquearUsuario = true
    },

    historicoAlteracaoUsuario (usuario) {
      this.usuarioSelecionado = usuario
      this.historicoUsuario = true
    },

    async getInfoAssinaturaToken (usuario) {
      this.usuarioSelecionado = await this.getInfoTokenAssinatura(usuario.id)
      this.showModalAssinaturaToken = true
    },

    editarUsuario (usuario) {
      this.$router.push({
        name: 'editarUsuario',
        params: {
          cpfCnpj: usuario.cpfCnpj
        }
      })
    },

    async closeModal () {
      this.visualizarUsuario = false
      this.bloquearUsuario = false
      this.alterarPerfil = false
      this.historicoUsuario = false
      this.showModalAssinaturaToken = false

      await this.searchUsuarios(this.paginaAtual)
    },

    isUsuarioLogado (usuario) {
      return usuario.cpfCnpj === this.usuarioLogado.pessoa.cpfCnpj
    }

  }
}
</script>

<style lang="scss" scoped>

  .card {
    margin: 0 3%;
    border-radius: 10px;
  }

  .button {
    display: flex;
    justify-content: flex-end;
  }

  .flex {
    display: flex;
    align-items: center;
    justify-content: left;
  }

  h1 {
    margin-top: 0px;
    font-size: 24px;
  }

  .lista {
      ul, li {
      margin: 0;
      padding: 0;
      list-style: none;
    }
  }

  .margin-top {
    margin-top: 40px;
  }

  .margin-bottom {
    margin-bottom: 40px;
  }

  .ativo {
    color: #009f61;
  }

</style>



// WEBPACK FOOTER //
// src/screens/portal/seguranca/AdministradorAcesso.vue